export default "__VITE_ASSET__D0hN7vqb__"